import React, { useContext } from 'react';
import { Box, Stack } from '@mui/material';
import { translate as t } from 'hooks/useTranslations';
import CommonLayout from '../../_layouts/CommonLayout';
import { AppContext } from 'views/App/context';
import { Alert, Typography } from '@mui/material';
import { neutral } from '_lex/_foundations/phxColors';
import { useDashboard } from '../context';
import RecommendedContent from './RecommendedContent';
import AssignmentGauge from './AssignmentGauge';
import TrainingSolutions from './TrainingSolutions';
import Assignments from './Assignments';

export default function TrainingDashboard() {
  const { hasPermissionError } = useContext(AppContext);
  const { tabs } = useDashboard();

  if (hasPermissionError) {
    return (
      <CommonLayout noPadding tabs={tabs}>
        <Box sx={{ px: 8, py: 10, backgroundColor: neutral[50] }}>
          <Alert severity='error' sx={{ mb: 2 }}>
            <Typography variant='body1'>
              Lexipol has encountered a problem retrieving your data, please contact Customer Support.
            </Typography>
          </Alert>
        </Box>
      </CommonLayout>
    );
  }

  return (
    <CommonLayout
      noPadding
      tabs={tabs}
    >
      <Box sx={{ px: 8, py: 10, backgroundColor: neutral[50] }}>
        <Box
          className='training-dashboard'
          sx={{
            display: 'grid',
            gridTemplateColumns: '3fr 1fr',
            gap: 10,
            width: 'calc(100vw - 160px)',
            maxWidth: '100%',
            minWidth: 0,
          }}
        >
          <Stack
            spacing={8}
            sx={{ minWidth: 0 }}
          >
            <RecommendedContent />
            <Assignments />
          </Stack>
          <Stack spacing={8}>
            <AssignmentGauge />
            <TrainingSolutions />
          </Stack>
        </Box>
      </Box>
    </CommonLayout>
  );
}
